export default "//yastatic.net/s3/distribution/pythia/frontend/_/c076586d884be965dde85227a099b86c.png";